export const trackCallClick = () => {
    try {
      window.gtag_report_conversion()
    } catch (error) {
      console.log(error, "book a call error");
    }
  }